import { getTranslation } from "../generate/translations";
import dayjsTZ from "../../../utils/dayjs";

/**
 * Shared column/row packing used by all report processors.
 */
export function buildReportResult(preFilter, columns, manualColumns) {
  const result = {
    columnsDef: [],
    allColumns: columns?.allAppliedColumnDefs || [],
    rowData: [],
    selectedColumns: manualColumns || columns?.columnDefs || [],
  };

  if (!columns && !manualColumns) return result;

  const keys =
    !!manualColumns && Array.isArray(manualColumns)
      ? manualColumns
      : columns?.columnDefs || [];

  keys.forEach((e) => {
    result.columnsDef.push(getTranslation(e));
  });

  (preFilter || []).forEach((record) => {
    const toAdd = [];
    keys.forEach((c) => toAdd.push(record?.[c] ?? ""));
    result.rowData.push(toAdd);
  });

  return result;
}

export function emptyReportResult(columns, manualColumns) {
  return {
    columnsDef: (manualColumns || columns?.columnDefs || []).map(getTranslation),
    allColumns: columns?.allAppliedColumnDefs || [],
    rowData: [],
    selectedColumns: manualColumns || columns?.columnDefs || [],
  };
}

export function employeeFullName(emp = {}) {
  return `${emp?.employeeFirstName || ""} ${emp?.employeeLastName || ""}`.trim();
}

export function intervalBounds(filter) {
  const start = dayjsTZ(filter?.timeInterval?.[0]).startOf("day");
  const end = dayjsTZ(filter?.timeInterval?.[1]).endOf("day");
  return {
    start,
    end,
    startTs: start.valueOf(),
    endTs: end.valueOf(),
  };
}

export function round2(n) {
  return parseFloat((Number(n) || 0).toFixed(2));
}

/** Weekday dates (Mon–Fri) between start/end as YYYY-MM-DD keys. */
export function weekdayKeysInRange(startTs, endTs) {
  const keys = [];
  let cur = dayjsTZ(startTs).startOf("day");
  const end = dayjsTZ(endTs).endOf("day");
  while (cur.valueOf() <= end.valueOf()) {
    const dow = cur.day();
    if (dow !== 0 && dow !== 6) keys.push(cur.format("YYYY-MM-DD"));
    cur = cur.add(1, "day");
  }
  return keys;
}
